import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LandingService } from '../landing.service';

@Component({
    selector: 'app-properties',
    templateUrl: './properties.component.html',
    styleUrls: ['./properties.component.scss', '../stylesGlobLanding.scss']
})
export class PropertiesComponent implements OnInit {

    domainPage: string;
    properties: any = [];

    /* sizeTable: number;z
    pageSize : number;
    page : number = 1;
    grupos_propiedad; */
    esSLP: boolean = false;
    bandera_seccion = 1;
    provinces: any = 'todos';
    state: any = "polonia ue";
    pageSize: number = 3;
    page: number = 1;
    collectionSize: number = 0;
    page_to_send = 1;
    typesProperty = [
        { "id": 1, "name": "Bodega comercial", "created_at": null, "updated_at": null },
        { "id": 2, "name": "Bodega industrial", "created_at": null, "updated_at": null },
        { "id": 3, "name": "Casa", "created_at": null, "updated_at": null },
        { "id": 4, "name": "Casa en condominio", "created_at": null, "updated_at": null },
        { "id": 5, "name": "Departamento", "created_at": null, "updated_at": null },
        { "id": 6, "name": "Edificio", "created_at": null, "updated_at": null },
        { "id": 7, "name": "Huerta", "created_at": null, "updated_at": null },
        { "id": 8, "name": "Local", "created_at": null, "updated_at": null },
        { "id": 9, "name": "Local comercial", "created_at": null, "updated_at": null },
        { "id": 10, "name": "Local en centro comercial", "created_at": null, "updated_at": null },
        { "id": 11, "name": "Nave industrial", "created_at": null, "updated_at": null },
        { "id": 12, "name": "Oficina", "created_at": null, "updated_at": null },
        { "id": 13, "name": "Otro", "created_at": null, "updated_at": null },

        { "id": 14, "name": "Quinta", "created_at": null, "updated_at": null },
        { "id": 15, "name": "Rancho", "created_at": null, "updated_at": null },
        { "id": 16, "name": "Terreno", "created_at": null, "updated_at": null },
        { "id": 17, "name": "Terreno Comercial", "created_at": null, "updated_at": null },
        { "id": 18, "name": "Terreno Industrial", "created_at": null, "updated_at": null },
        { "id": 19, "name": "Terreno Ejidal", "created_at": null, "updated_at": null },
        { "id": 20, "name": "Villa", "created_at": null, "updated_at": null },
        { "id": 21, "name": "Casa con uso de suelo", "created_at": null, "updated_at": null }
    ];
    consulta = {
        type_operation: '',
        typeProperty: '',
        prices_min: '',
        prices_max: '',
        province: 'todos',
        page: 1,
    }

    proyecto: any;

    constructor(private _router: Router, private _LandingService: LandingService) {
        var host = window.location.host;
        const domain = host.split('.')[1];
        let data;
        if (domain == 'ampi') {
            this.domainPage = host.split('.')[0];
        } else {
            this.domainPage = window.location.host;
        }
        // this.domainPage = 'sanluispotosi';
        if (this.domainPage == 'ampisanluis' || this.domainPage == 'sanluispotosi') {
            this.esSLP = true;
        }
        console.log("este es el dominio", this.domainPage);


    }


    viewProperty(idProperty: number) {
        console.log('ID DE MI PROPIEDAD', idProperty);
        // const url = this._router.createUrlTree(['property/' + idProperty]);
        // const url = this._router.createUrlTree(['property/'], { queryParams: { id: idProperty } }).toString();
        const url = this._router.createUrlTree(['property/' + idProperty], { queryParams: { page: this.page_to_send } });



        console.log('URL PROPIEDAD', url);
        window.open(url.toString(), '_blank')
    }

    async ngOnInit() {
        this.proyecto = await this._LandingService.getProyecto('dacita');
        console.log('proyecto', this.proyecto);
        // this.typesProperty = await this._LandingService.getServer2('property_types');
        this._LandingService.getServer('usAssociation', this.domainPage).then(
            (resp: any) => {
                console.log(resp);
                if (resp.ampi_section == null || resp.ampi_section == '') {
                    this.bandera_seccion = 0;
                    this.consulta.province = resp.province;
                }
            });
        this.state = await this._LandingService.getServer2('get-state/' + this.domainPage);
        this.provinces = await this._LandingService.getServer2('get-provinces/' + this.domainPage);
        console.log("auxilio", this.typesProperty);
        const url = "getProperties/" + this.domainPage;
        this.properties = await this._LandingService.getServerWithPage('getProperties', this.domainPage, this.page)
        console.log("estas son las propiedades", this.properties);
        console.log(this.consulta);
        localStorage.setItem('consulta', JSON.stringify(this.consulta));


        // await this.loadData();
    }

    getroperties(page?) {
        this.page = page;
        return new Promise((resolve, reject) => {
            console.log('DENTRO DEL PROMISE', page)
            if (!page) page = 1;
            this._LandingService.getServerWithPage('getProperties', this.domainPage, Number(page)).then(
                (resp: any) => {
                    console.log('RESP PROPERTIES', resp)
                    // this.properties = resp.data;
                    this.collectionSize = resp.total;
                    this.page_to_send = resp.current_page;
                    resolve(resp.data);
                }, (error: any) => {
                    console.log("ERROR getProperties", error);
                    reject(error);
                }
            );
        });
    }


    async onPageChange() {
        console.log(this.page);
        if (this.bandera_seccion == 1) {
            console.log('Entro a onPageChange', this.page);
            const url = "getProperties/" + this.domainPage;
            this.properties = await this._LandingService.getServerWithPage('getProperties', this.domainPage, this.page)
        }
        else {
            console.log('Entro a onPageChange', this.page);
            this.consulta.page = this.page;
            localStorage.setItem('consulta', JSON.stringify(this.consulta));
            const url = "getPropertiesRequest/" + this.domainPage;
            console.log(this.consulta);
            this.properties = await this._LandingService.postServer(url, this.consulta)
            this.page_to_send = this.properties.current_page;
            console.log(this.properties);
        }
    }

    /* getPaginatedObjetos(): any[] {
        if(this.properties){
            const startIndex = (this.page - 1) * this.pageSize;
            console.log('startIndex', startIndex);
            console.log('AVER', this.properties.slice(startIndex, startIndex + this.pageSize));
            return this.properties.slice(startIndex, startIndex + this.pageSize);
        }
    } */

    async loadData() {
        let menor_que_10 = false;
        // let mayor_que_100 = false;
        let api_between_pages = { first: 1, middle: 2, last: 3 };
        let digit_one = String(this.page).substring(0, 1);
        let digit_two: any = String(this.page).substring(1, 2); //Es mayor que 9
        let digit_three: any = String(this.page).substring(2, 3); //Es mayor que 100
        console.log('DIGIT_TWO AA', digit_two);
        if (!digit_two) {
            digit_two = String(this.page).substring(0, 1); //Es menor que 10
            menor_que_10 = true;
        }
        let properties1;
        let properties2;
        let properties3;
        console.log('DIGIT_TWO BB', digit_two);


        // if(this.page < 100){
        if (Number(digit_two) != 0) {
            console.log('DIGIT_ONE', digit_one, 'menor_que_10', menor_que_10);
            if (menor_que_10) {
                api_between_pages.first = 1;
                api_between_pages.middle = 2;
                api_between_pages.last = 3;
            }
            else if (this.page < 100) {
                api_between_pages.first = (Number(digit_one) * 3) + 1;
                api_between_pages.middle = Number(api_between_pages.first) + 1;
                api_between_pages.last = Number(api_between_pages.first) + 2;
            } else if (this.page >= 100) {
                api_between_pages.first = (Number(digit_one + digit_two) * 3) + 1;
                api_between_pages.middle = Number(api_between_pages.first) + 1;
                api_between_pages.last = Number(api_between_pages.first) + 2;
            }

            if (digit_two == 1 || digit_two == 2 || digit_two == 3) {
                // Pagina uno(3Total9)
                properties1 = await this.getroperties(api_between_pages.first);
                if (digit_two == 1) this.properties = [properties1[0], properties1[1], properties1[2]];
                if (digit_two == 2) this.properties = [properties1[3], properties1[4], properties1[5]];
                if (digit_two == 3) this.properties = [properties1[6], properties1[7], properties1[8]];
            }
            if (digit_two == 4) {
                // Pagina uno(1) y dos(2)
                properties1 = await this.getroperties(api_between_pages.first);
                properties2 = await this.getroperties(api_between_pages.middle);
                this.properties = [properties1[9], properties2[0], properties2[1]];
            }
            if (digit_two == 5 || digit_two == 6) {
                // Pagina dos(3Total6)
                properties2 = await this.getroperties(api_between_pages.middle);
                if (digit_two == 5) this.properties = [properties2[2], properties2[3], properties2[4]];
                if (digit_two == 6) this.properties = [properties2[5], properties2[6], properties2[7]];
            }
            if (digit_two == 7) {
                // Pagina dos(2) y tres(1)
                properties2 = await this.getroperties(api_between_pages.middle);
                properties3 = await this.getroperties(api_between_pages.last);
                this.properties = [properties2[8], properties2[9], properties3[0]];
            }
            if (digit_two == 8 || digit_two == 9) {
                // Pagina tres(3Tota6)
                properties3 = await this.getroperties(api_between_pages.last);
                if (digit_two == 8) this.properties = [properties3[1], properties3[2], properties3[3]];
                if (digit_two == 9) this.properties = [properties3[4], properties3[5], properties3[6]];
            }

            // this.page_to_send = 0;

        } else {
            let digit_one = String(this.page).substring(0, 1);
            api_between_pages.last = Number(digit_one) * 3;
            api_between_pages.first = api_between_pages.last - 2;

            properties3 = await this.getroperties(api_between_pages.last);
            this.properties = [properties3[7], properties3[8], properties3[9]];
        }
        console.log('FINALIZA LOAD DATA', this.properties);
        /* }else if (this.page >= 100){
            console.log('digit_one', digit_one);
            console.log('digit_three', digit_three);

            let two_digits_number = digit_one+digit_two;
            api_between_pages.first = (Number(digit_one+digit_two) * 3)+1;
            api_between_pages.middle = Number(api_between_pages.first) + 1;
            api_between_pages.last = Number(api_between_pages.first) + 2;
            console.log('api_between_pages.first', api_between_pages.first);
        } */
    }

    async buscar(objeto) {
        this.bandera_seccion = 0;
        console.log(objeto);
        this.consulta.page = 1;
        if (objeto.province != 'null') {
            this.consulta.province = objeto.province;
        }
        if (objeto.typeProperty != 'null') {
            this.consulta.typeProperty = objeto.typeProperty;
        }
        if (objeto.type_operation != 'null') {
            this.consulta.type_operation = objeto.type_operation;
        }
        if (objeto.prices_min != '') {
            this.consulta.prices_min = objeto.prices_min;
        }
        else {
            this.consulta.prices_min = '';

        }
        if (objeto.prices_max != '') {
            this.consulta.prices_max = objeto.prices_max;
        }
        else {
            this.consulta.prices_max = '';
        }
        console.log(this.consulta);
        const url = "getPropertiesRequest/" + this.domainPage;
        localStorage.setItem('consulta', JSON.stringify(this.consulta));
        this.properties = await this._LandingService.postServer(url, this.consulta);
        this.page_to_send = this.properties.current_page;
        console.log(this.properties);
    }

}
